import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckboxChecked = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 14,
	height: 14,
	fill: "none",
	viewBox: "0 0 14 14",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "m4.7 6.285 1.296 1.27L9.297 4.29l1.406 1.422-4.699 4.65L3.3 7.716z"
	})
});
export default SvgCheckboxChecked;
